import { label } from "@omni/ui/brand/product/label/label.style";
import { ReactNode } from "react";

import { useLabelContext } from "../context/label.context";
import { LabelVariantsProps } from "../label.props";

type Props = {
    variant?: LabelVariantsProps["variant"];
    className?: string;
    children: ReactNode;
};

export const Entry = ({ variant, className, children }: Props) => {
    const { position, type } = useLabelContext();

    const { entry } = label({ position, type, variant });

    return <span className={entry({ className })}>{children}</span>;
};
